import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AJAXOptionButton } from './ajax-option-button';
import { Helpers } from 'shared-components/helpers/helpers';
import publicConfig from '../../../public-config';
import Copy from 'copy-to-clipboard';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";

const host = publicConfig.external_address;

class InviteShareBtn extends Component {
  constructor (props) {
    super(props);
    this.state = {
      title: '',
      showAlternateSuccessMsg: false
    };
    this.clickAction = this.clickAction.bind(this);
    this.clickActionCb = this.clickActionCb.bind(this);
    this.btnClick = this.btnClick.bind(this);
  }

  btnClick (e) {
    this.refs.attendeeBtn.clickFn(e);
  }

  clickAction (e, callback) {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const { pid, actions, link, removeInput, alternateSuccessMsg } = this.props;
    const { shareLink } = this.refs;
    const prefix = urlPrefix ? `/${urlPrefix}` : '';
    const copyLink = pid ? `${host}${prefix}/invite/${pid}` : `${host}${prefix}${link}`;
    actions.click();
    if (!removeInput) {
      shareLink.focus();
      shareLink.select();
    }
    Copy(copyLink);
    this.setState({ title: this.props.intl.formatMessage({ id: 'web_2.invite_share_btn.copied', defaultMessage: 'Copied!' }) });
    if (alternateSuccessMsg) {
      this.setState({ showAlternateSuccessMsg: true });
    }
    setTimeout(() => {
      callback();
    }, 500);
  }

  clickActionCb () {
    setTimeout(() => {
      this.setState({ title: '', showAlternateSuccessMsg: false });
    }, 1500);
  }

  render () {
    const {
      pid,
      minWidth,
      btnColor,
      link,
      removeInput,
      optionalBtnStyle,
      btnSize,
      inputContainerClassName,
      inputClassName,
      btnContainerClassName,
      className,
      visibleMobile,
      iconInsideInput,
      iconInsideBtn,
      alternateSuccessMsg
    } = this.props;

    const { title, showAlternateSuccessMsg } = this.state;
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const copyLink = pid ? `${urlPrefix ? `/${urlPrefix}` : ''}/invite/${pid}` : link;
    const containerProps = {
      className: classnames('input-btn-container', className)
    };
    if (optionalBtnStyle) {
      Object.assign(containerProps, { style: optionalBtnStyle });
    }
    return (
      <div { ...containerProps } data-testing-id="invite-share-btn-container">
        {
          removeInput ?
            null :
            <div className={classnames('invite-input inline-block', { 'hidden-xs': !visibleMobile }, inputContainerClassName)} data-testing-id="invite-share-input">
              <span className="invite-copy-btn" onClick={(e) => this.clickAction(e, this.clickActionCb)}>{showAlternateSuccessMsg ? alternateSuccessMsg : iconInsideInput }</span>
              <input ref="shareLink" className={classnames('form-control', inputClassName)} onClick={this.btnClick} value={`${host}${copyLink}`} readOnly aria-readonly />
            </div>
        }
        <div className={classnames('inline-block', { 'share-btn-block': !visibleMobile }, btnContainerClassName)}>
          <AJAXOptionButton
            ref="attendeeBtn"
            clickAction={this.clickAction}
            buttonClass={`btn ${btnSize || 'classic'} ${btnColor || 'btn-primary'}`}
            buttonText={title || this.props.title}
            minWidth={minWidth}
            clickCallback={this.clickActionCb}
            iconInBtn={iconInsideBtn}
          />
        </div>
      </div>
    );
  }
}

InviteShareBtn.propTypes = {
  pid: PropTypes.string,
  minWidth: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object  /* JSX compiled */
  ]),
  actions: PropTypes.object,
  btnColor: PropTypes.string,
  link: PropTypes.string,
  removeInput: PropTypes.bool,
  optionalBtnStyle: PropTypes.object,
  btnSize: PropTypes.string,
  inputContainerClassName: PropTypes.string,
  className: PropTypes.string
};

exports.InviteShareBtn = injectIntl(InviteShareBtn);
